var initUnderAgePopup = function initUnderAgePopup() {
  var popup = document.querySelector(".under-age");
  var over21Btn = document.getElementById("btn-over21");
  if (!popup || !over21Btn) return;
  var hasConfirmed = sessionStorage.getItem("isOver21");
  var bypassPopup = window.location.search.includes("utm_term=gate") || false;
  if (!hasConfirmed && !bypassPopup) {
    popup.classList.add("visible");
  }
  if (bypassPopup) {
    sessionStorage.setItem("isOver21", "true");
  }
  over21Btn.addEventListener("click", function () {
    sessionStorage.setItem("isOver21", "true");
    popup.classList.remove("visible");
  });
};
export { initUnderAgePopup };